export function marinaSourceId(marina = {}) {
  return marina.id ? `marina:${marina.id}` : "";
}

export function buildMarinaTranslationMap(rows = []) {
  return rows.reduce((map, row) => {
    if (row?.source_id) map[row.source_id] = row;
    return map;
  }, {});
}

function pickTranslation(marina, translations, lang) {
  if (!marina || !lang || lang === "en") return null;
  const sourceId = marinaSourceId(marina);
  return translations?.[sourceId] || translations?.[marina.id] || marina.translations?.[lang] || null;
}

export function localizeMarina(marina, translations, lang = "en") {
  const translation = pickTranslation(marina, translations, lang);
  if (!translation) return marina;

  return {
    ...marina,
    name: translation.title || translation.name || marina.name,
    description: translation.content || translation.description || marina.description,
    facilities: translation.facilities || marina.facilities,
    mooring_types: translation.mooring_types || marina.mooring_types,
    experience_tags: translation.experience_tags || marina.experience_tags,
    localized_language: lang,
    localized_meta_title: translation.meta_title,
    localized_meta_description: translation.meta_description,
  };
}